require("./bootstrap");

window.Vue = require("vue");

import tinymce from "tinymce/tinymce";
import "tinymce/themes/silver/theme";
import "tinymce/themes/mobile/theme";
import "tinymce/plugins/link";
import "tinymce/plugins/autolink";
import Editor from "@tinymce/tinymce-vue";

import BootstrapVue from "bootstrap-vue";

window.Vue.use(BootstrapVue);

import "bootstrap-vue/dist/bootstrap-vue.css";

import sponsoredImg from "./components/sponsored-img";
import articles from "./components/articles/articles";
import imageCollectionsOverview from "./components/image-collections/image-collections-overview";
import imageModal from "./components/image-modal";
import alert from "./components/alert";
import paginator from "./components/paginator";
import articleEditor from "./components/articles/article-editor";
import imageDropzone from "./components/images/image-dropzone";
import imageCollections from "./components/image-collections/image-collections";

Vue.component("sponsored-img", sponsoredImg);
Vue.component("articles", articles);
Vue.component("image-collections-overview", imageCollectionsOverview);
Vue.component("image-modal", imageModal);
Vue.component("alert", alert);
Vue.component("paginator", paginator);
Vue.component("editor", Editor);
Vue.component("article-editor", articleEditor);
Vue.component("image-dropzone", imageDropzone);
Vue.component("image-collections", imageCollections);

if (document.getElementById("app")) {
    const app = new Vue({
        el: "#app"
    });
}
